import styled from "@emotion/styled";

const HomeForm = styled.div`
  max-width: 600px;
`;

export default HomeForm;
